import React from 'react';
import '../styles/Navbar.css';
import { RESTAURANT_NAME, NAVIGATION_LINKS } from '../constants/data';

function Navbar() {
  return (
    <nav className="navbar">
      <div className="navbar-brand" onClick={() => window.location.href = "#home"}>
        <h1>{RESTAURANT_NAME}</h1>
      </div>
      <div className="navbar-links">
        {NAVIGATION_LINKS.map(link => (
          <a key={link.id} href={link.href}>{link.label}</a>
        ))}
      </div>
    </nav>
  );
}

export default Navbar;
